// extracted by mini-css-extract-plugin
export default {"row":"action-button_row__dqq2X","text":"action-button_text__tzUt8"};